import { Component, Input } from '@angular/core';

import { DiffLine } from '../../../services/env-sync/types';

@Component({
  selector: 'app-json-diff',
  templateUrl: './json-diff.component.html',
  styleUrls: ['./json-diff.component.scss'],
})
export class JsonDiffComponent {
  @Input() diffLines: DiffLine[] = [];
  @Input() title: string = '';

  trackByLineNumber(index: number, line: DiffLine): number {
    return line.lineNumber ?? index;
  }
}
